import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Button, Modal, Typography } from 'antd';
import BankSlipReturnFileModal from './BankSlipReturnFileModal';
import { useDisclosure } from '@/hooks';
import { useBankSlipFormContext } from '@/pages/FinancialPages/BankSlipPage';
import { ReturnFileBankSlipRequest } from '@/core/domain/financial/Boletos/Boletos.types';
import { useReturnFile } from '@/core/domain/financial/Boletos/Boletos.hooks';

export default function ReturnFileButton() {
  const { queryParams } = useBankSlipFormContext();

  const [returnFileOpened, returnFileAction] = useDisclosure();

  const returnFileMutation = useReturnFile();

  const handleReturnFile = async (values: ReturnFileBankSlipRequest) => {
    const response = await returnFileMutation.mutateAsync({ ...values });

    if (response.message && response.protocol) {
      Modal.confirm({
        title: 'Resposta da Leitura do Arquivo de Retorno',
        content: (
          <>
            <p>
              <strong>Messagem: </strong>
              <Typography.Text>{response.message}</Typography.Text>
            </p>

            <p>
              <strong>Protocolo: </strong>
              <Typography.Text>{response.protocol}</Typography.Text>
            </p>
          </>
        ),
      });
    }
  };

  return (
    <>
      <Button
        disabled={
          !hasPermissions([Authorities.FINANCIAL_BILL_READ_RETURN_FILE])
        }
        block
        type="primary"
        onClick={returnFileAction.open}
      >
        Leitura arquivo de retorno
      </Button>

      <BankSlipReturnFileModal
        open={returnFileOpened}
        onCancel={returnFileAction.close}
        onCallback={handleReturnFile}
        companyId={queryParams.companyId}
      />
    </>
  );
}
